import React from 'react';
import LocationTemplate from './LocationTemplate';

const AirliePage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Airlie"
      stateName="North Carolina"
      countyName="Halifax"
      zipCodes={["27820"]}
      latitude={36.2271}
      longitude={-77.4108}
      population={null}
      historicalFact="Small rural community in Halifax County."
      nearbyTowns={[
        "Enfield, NC",
        "Scotland Neck, NC",
        "Halifax, NC",
        "Hobgood, NC",
        "Whitakers, NC",
        "Rocky Mount, NC",
        "Roanoke Rapids, NC",
        "Weldon, NC"
      ]}
    />
  );
};

export default AirliePage;